export const customFormDataFn = <Body>(body: Body): FormData => {
	const formData = new FormData()
	if (body && typeof body === 'object' && !(body instanceof Blob)) {
		for (const [key, value] of Object.entries(body)) {
			if (value instanceof Blob) {
				formData.append(key, value)
			} else if (typeof value === 'object' && value !== null) {
				const jsonBlob = new Blob([JSON.stringify(value)], { type: 'application/json' })
				formData.append(key, jsonBlob)
			} else if (value !== undefined && value !== null) {
				formData.append(key, String(value))
			}
		}
	} else {
		throw new Error('Body must be an object or a Blob')
	}
	return formData
}
